export default {
  namespaced: true,
  patrol_logs: {
    title: "Patrullaje",
    add_unit_log: "Adicionar Registro de Bitácora",
    patrol_log: {
      title: "Patrol Log",
      unit_log: "Registro de Unidade",
      select_unit_log: "Selecionar registro de unidade",
      unit: "Instalação",
      select_unit: "Selecionar unidade",
      shipping_time: "Hora de Envio",
      arrival_time: "Hora de Chegada",
      departure_time: "Horário de Partida",
      revision_code: "Código de Revisão",
      select_revision_code: "Selecionar código de revisão",
      comments: "Comentários",
      assignment: "Atribuição",
      surveillance: "Sob vigilância",
      command_officer: "Oficial de comando",
      select_command_officer: "Selecionar Oficial de comando",
      patrol_officer: "Policial de patrulha",
      select_patrol_officer: "Selecionar Policial de patrulha",
      created_success: "Registro de patrulha criado com sucesso",
      updated_success: "Registro de patrulha atualizado com sucesso",
      deleted_success: "Registro de patrulha excluído com sucesso",
      review_time: "Tempo de revisão",
      travel_time: "Tempo de viagem",
    },
    unit_log: {
      title: "Unit Log",
      unit: "Número da unidade",
      select_unit: "Selecionar unidade",
      commander: "Comandante",
      select_commander: "Selecionar comandante",
      patrol_office: "Policial de Patrulha",
      telephone_number: "Número de Telefone",
      router_number: "Número da Rota",
      active: "Ativo",
      select_status: "Selecionar status",
      created_success: "Registro de unidade criado com sucesso",
      updated_success: "Registro de unidade atualizado com sucesso",
      deleted_success: "Registro de unidade excluído com sucesso",
    },
    unit_commander: {
      title: "Unit Commanders",
      name: "Nome",
      telephone_number: "Número de Telefone",
      placeholder_name: "Digite o nome",
      placeholder_telephone: "Digite o número de telefone",
      no_filters: "Nenhum filtro disponível",
      created_success: "Comandante de unidade criado com sucesso",
      updated_success: "Comandante de unidade atualizado com sucesso",
      deleted_success: "Comandante de unidade excluído com sucesso",
    },
    revision_code: {
      title: "Código de revisão",
      name: "Nome",
      code: "Código",
      placeholder_name: "Digite o nome",
      placeholder_code: "Digite o código",
      no_filters: "Nenhum filtro disponível",
      created_success: "Código de revisão criado com sucesso",
      updated_success: "Código de revisão atualizado com sucesso",
      deleted_success: "Código de revisão excluído com sucesso",
    },
  },
};
